import { Stack } from '@optimus-web/core';
import { Service } from '@mews-commander/data-access';
import { ItemsServiceForm } from './ItemsServiceForm';

export const ItemsServiceList = ({ services }: { services: Service[] }) => (
    <Stack vertical distribution="stretch" spacing="200">
        {services.map((service, index) => (
            <ItemsServiceForm key={service.id} isOneService={services.length === 1} index={index} service={service} />
        ))}
    </Stack>
);
